import { render, staticRenderFns } from "./NavigatorBottomBarLinkWorkout.vue?vue&type=template&id=4f0e4a69"
import script from "./NavigatorBottomBarLinkWorkout.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkWorkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports